// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/shared/Layout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";

import Employee from "./pages/Employee";
import Attendance from "./pages/Attendance";
import Leaves from "./pages/Leaves";
import Task from "./pages/Task";
import { Toaster } from "react-hot-toast";
import Logout from "./pages/Logout";
import ProtectedRoute from "./private/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        {/* <Toaster /> */}
        <Toaster 
      position="top-right" 
      toastOptions={{
        style: {
          background: '#f2f2f2',
          color: '#000000',
        },
      }}
    />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="employee" element={<Employee />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="task" element={<Task />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
